import { render, staticRenderFns } from "./pricelist_protocols.vue?vue&type=template&id=df3236b4&"
import script from "./pricelist_protocols.vue?vue&type=script&lang=js&"
export * from "./pricelist_protocols.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports